// extracted by mini-css-extract-plugin
export default {"card":"r2-z"};